




































































































































import { generate } from '@ant-design/colors';

import ThemePreviewer from '@/components/ThemePreviewer.vue';
import Organization from '@/model/Organization';

export default {
	name: 'WhiteLabel',
	components: {
		ThemePreviewer,
	},
	data() {
		return {
			whiteLabel: {
				light: {
					colorPrimary: '#1A959A',
					colorBgBase: '#FFFFFF',
					titlebar: '#2a4c5c',
				},
				dark: {
					colorPrimary: '#1A959A',
					colorBgBase: '#000000',
					titlebar: '#2a4c5c',
				},
			},
			dashboardLogo: this.$store.state.ramboxLogo,
			nameField: '',
			loading: false,
			theme: 'light',
			predefine: ['#2a4c5c', '#1A959A', '#272b42', '#FFFFFF', '#000000'],
		};
	},
	computed: {
		organization(): Object {
			return this.$store.state.organization;
		},
		currentWhiteLabel(): Organization['whiteLabel'] {
			if (!this.organization.whiteLabel.light) {
				const { primaryColor, sectionColor } = this.organization.whiteLabel;
				return {
					light: {
						colorPrimary: primaryColor || '#1A959A',
						colorBgBase: sectionColor || '#FFFFFF',
						titlebar: '#2a4c5c',
					},
					dark: {
						colorPrimary: primaryColor || '#1A959A',
						colorBgBase: sectionColor || '#000000',
						titlebar: '#2a4c5c',
					},
				};
			}
			return this.$store.state.organization.whiteLabel;
		},
		differentData(): Boolean {
			return (
				this.whiteLabel.light.colorPrimary === this.currentWhiteLabel.light.colorPrimary &&
				this.whiteLabel.light.colorBgBase === this.currentWhiteLabel.light.colorBgBase &&
				this.whiteLabel.light.titlebar === this.currentWhiteLabel.light.titlebar &&
				this.whiteLabel.dark.colorPrimary === this.currentWhiteLabel.dark.colorPrimary &&
				this.whiteLabel.dark.colorBgBase === this.currentWhiteLabel.dark.colorBgBase &&
				this.whiteLabel.dark.titlebar === this.currentWhiteLabel.dark.titlebar &&
				this.nameField === this.organization.name &&
				this.dashboardLogo === this.organization.logo
			);
		},
	},
	watch: {
		// LIGHT
		'whiteLabel.light.colorPrimary': (newValue, oldValue) => {
			if (newValue === oldValue) return;
			document.body.style.setProperty(`--light-colorPrimary`, newValue);

			const colors = generate(newValue, { theme: 'default' });
			document.body.style.setProperty(`--light-colorPrimaryBg`, colors[0]);
			document.body.style.setProperty(`--light-colorPrimaryBgHover`, colors[1]);
		},
		'whiteLabel.light.colorBgBase': (newValue, oldValue) => {
			if (newValue === oldValue) return;
			const colors = generate(newValue, { theme: 'default' });

			document.body.style.setProperty(`--light-colorBgBase`, newValue);
			document.body.style.setProperty(`--light-colorFillSecondary`, 'rgba(0, 0, 0, 0.06)');
		},
		'whiteLabel.light.titlebar': (newValue, oldValue) => {
			if (newValue === oldValue) return;
			document.body.style.setProperty(`--light-titlebar`, newValue);
		},
		// DARK
		'whiteLabel.dark.colorPrimary': (newValue, oldValue) => {
			if (newValue === oldValue) return;
			document.body.style.setProperty(`--dark-colorPrimary`, newValue);

			const colors = generate(newValue, { theme: 'dark' });
			document.body.style.setProperty(`--dark-colorPrimaryBg`, colors[0]);
			document.body.style.setProperty(`--dark-colorPrimaryBgHover`, colors[1]);
		},
		'whiteLabel.dark.colorBgBase': (newValue, oldValue) => {
			if (newValue === oldValue) return;
			const colors = generate(newValue, { theme: 'dark' });
			console.log(colors);

			document.body.style.setProperty(`--dark-colorBgBase`, newValue);
			document.body.style.setProperty(`--dark-colorFillSecondary`, 'rgba(0, 0, 0, 0.06)');
		},
		'whiteLabel.dark.titlebar': (newValue, oldValue) => {
			if (newValue === oldValue) return;
			document.body.style.setProperty(`--dark-titlebar`, newValue);
		},
		//////////
		'organization.whiteLabel'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.setValues(newValue);
		},
		'organization.logo'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.dashboardLogo = newValue;
		},
		'organization.name'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.nameField = newValue;
		},
	},
	methods: {
		showPicker(value): void {
			this.$refs[value].showPicker = true;
		},
		setValues(data): void {
			// Light
			this.whiteLabel.light.colorPrimary = data.light.colorPrimary || null;
			this.whiteLabel.light.colorBgBase = data.light.colorBgBase || null;
			this.whiteLabel.light.titlebar = data.light.titlebar || null;
			// Dark
			this.whiteLabel.dark.colorPrimary = data.dark.colorPrimary || null;
			this.whiteLabel.dark.colorBgBase = data.dark.colorBgBase || null;
			this.whiteLabel.dark.titlebar = data.dark.titlebar || null;
		},
		onPickFile(): void {
			this.$refs.fileInput.click();
		},
		onFilePicked(e): void {
			let files = e.target.files;
			if (files[0] !== undefined) {
				if (files[0].type !== 'image/png') {
					files = [];
					this.$message.error('App logo must be png format!');
					return;
				}
				var image = new Image();
				const fileReader = new FileReader();
				fileReader.addEventListener('load', () => {
					image.src = fileReader.result as string;
					image.addEventListener('load', () => {
						image.height > 128 || image.width > 128
							? this.$message.error('App logo must be less or equal than 128px x 128px!')
							: (this.dashboardLogo = fileReader.result);
					});
				});
				fileReader.readAsDataURL(files[0]);
			}
		},
		async saveChanges(): Promise<void> {
			try {
				await this.$confirm(this.$t('whiteLabel.saveConfirmMessage'), this.$t('whiteLabel.saveConfirmTitle'), {
					confirmButtonText: this.$t('common.ok'),
					cancelButtonText: this.$t('common.cancel'),
					type: 'info',
				});
				this.loading = true;
				await this.$firebase.functions().httpsCallable('editWhiteLabel')({
					data: {
						logo: this.dashboardLogo || this.$options.data.call(this).dashboardLogo,
						whiteLabel: this.whiteLabel,
						name: this.nameField || '',
					},
					path: this.$store.getters.path,
				});
				this.loading = false;
				this.$message({
					type: 'success',
					message: this.$t('whiteLabel.saved'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: error,
				});
			}
		},
		resetChanges(): void {
			this.dashboardLogo = this.organization.logo;
			this.setValues(this.organization.whiteLabel);
		},
	},
	mounted() {
		this.organization.whiteLabel && this.setValues(this.currentWhiteLabel);
		this.organization.logo && (this.dashboardLogo = this.organization.logo);
		this.organization.name && (this.nameField = this.organization.name);
	},
};
